// extracted by mini-css-extract-plugin
module.exports = {"sidePanelContainer":"view-end-of-day_sidePanelContainer__1DP96"};